<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div
      class="constrained-content flex-space-between"
      style="align-items: center"
    >
      Upgrade to add the embeddable chat widget to your site
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="chatbubbles-outline"></ion-icon>Embedded Live Chat
          </h1>
          <p class="subtitle">
            Add live chat or a customer portal to your website, forward messages
            into a Slack channel, and respond from Slack or your Unthread
            dashboard.
          </p>
          <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <a (click)="showWidgetHelpdesk()">
              Learn more about the embedded in-app chat
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
          </p>
          <div
            class="flexed-align-center subtitle"
            style="opacity: 1; margin-bottom: 15px"
          >
            <label class="switch">
              <input
                type="checkbox"
                [(ngModel)]="isReplyPublic"
                (change)="isReplyPublicDidChange()"
              />
              <span class="slider"></span>
            </label>
            <ion-label
              style="margin-left: 5px"
              ngxTippy
              [tippyProps]="{
                touch: false,
                arrow: false,
                allowHTML: true,
                placement: 'bottom',
                content:
                  '<b>Replies from Slack</b><p>Enable this setting to send Slack messages as replies back to the customer. If disabled, you will need to append <i>/unthread send</i> to your message to send it</p><p>Note: this is a global setting</p>'
              }"
            >
              Slack messages are replies by default
              <ion-icon name="information-circle"></ion-icon>
            </ion-label>
          </div>
          <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <ion-badge color="warning" *ngIf="!hasWidgets">
              Not configured yet
            </ion-badge>
            <ion-badge color="success" *ngIf="hasWidgets"> Enabled </ion-badge>
          </p>
        </ion-col>

        <ion-col size-md="7" size="12">
          <ion-card
            class="outline-card"
            *ngIf="!hasWidgets"
            style="margin: 10px 10px 30px 10px"
          >
            <div class="empty-state-container" style="padding: 60px">
              <span class="placeholder-emoji">
                <ion-icon name="chatbubble-outline"></ion-icon>
              </span>
              <h1 class="placeholder-title">No configurations yet</h1>
              <p class="placeholder-subtitle">
                Click the button below to set one up
              </p>
            </div>
          </ion-card>
          <ion-card
            class="outline-card"
            *ngFor="let widget of widgets"
            style="margin: 10px 10px 30px 10px"
          >
            <h3 style="margin: 20px 20px 5px 20px">
              {{ widget.name }}
            </h3>
            <ion-list>
              <ion-item>
                <ion-icon
                  class="list-left-icon"
                  [name]="
                    widget.isFullPageView
                      ? 'desktop-outline'
                      : 'chatbubble-outline'
                  "
                ></ion-icon>
                {{
                  widget.isFullPageView
                    ? "Customer Portal"
                    : "In-app Chat Bubble"
                }}
              </ion-item>
              <ion-item>
                <ion-icon name="logo-slack" class="list-left-icon"></ion-icon>
                Slack channel: #{{ widget.slackChannel.name }}
              </ion-item>
              <ion-item>
                <ion-icon
                  name="ellipse"
                  color="success"
                  class="list-left-icon"
                ></ion-icon>
                Status: active
              </ion-item>
            </ion-list>
            <div style="border-top: 1px solid var(--ion-subtle-border-color)">
              <ion-button fill="clear" (click)="editWidget(widget)">
                <ion-icon name="cog-outline" class="padded-icon"></ion-icon>
                Edit configuration
              </ion-button>
            </div>
            <div>
              <ion-button fill="clear" (click)="viewInbox(widget)">
                <ion-icon
                  name="file-tray-outline"
                  class="padded-icon"
                ></ion-icon>
                View conversations
              </ion-button>
            </div>
          </ion-card>
          <ion-button
            class="btn-large"
            size="block"
            style="margin: 32px 12px"
            (click)="addWidget()"
          >
            <ion-icon name="add-outline" class="padded-icon"></ion-icon>Create
            in-app chat or customer portal
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-modal
  [isOpen]="showConfigModal"
  class="modal-large"
  (willDismiss)="onDismissConfigModal()"
>
  <ng-template>
    <ion-content>
      <ion-grid class="no-padding">
        <ion-row class="no-padding">
          <ion-col
            size="12"
            size-md="6"
            style="
              background: var(--ion-item-background);
              padding: 10px;
              border-right: 1px solid var(--ion-subtle-border-color);
            "
          >
            <ion-card-header class="flex-space-between">
              <div style="width: 100%">
                <ion-input
                  [(ngModel)]="widgetToEdit.name"
                  class="input-field big-title-input"
                  placeholder="Name your in-app chat widget (ex: 'Website')"
                  autocapitalize="sentences"
                >
                </ion-input>
              </div>
            </ion-card-header>
            <ion-card-content>
              <ion-grid class="no-padding" style="margin-bottom: 25px">
                <ion-row class="no-padding">
                  <ion-col size="6" class="no-padding">
                    <ion-card
                      class="depthButton select-outline mode-toggle"
                      [ngClass]="{
                        'mode-toggle-selected': !widgetToEdit.isFullPageView
                      }"
                      (click)="widgetToEdit.isFullPageView = false"
                    >
                      <ion-icon name="chatbubble-outline"></ion-icon>
                      In-app Chat
                      <br />
                      <span style="font-weight: 400"
                        >Embed a chat bubble into your site</span
                      >
                    </ion-card>
                  </ion-col>
                  <ion-col size="6" class="no-padding">
                    <ion-card
                      class="depthButton select-outline mode-toggle"
                      [ngClass]="{
                        'mode-toggle-selected': widgetToEdit.isFullPageView
                      }"
                      (click)="widgetToEdit.isFullPageView = true"
                    >
                      <ion-icon name="desktop-outline"></ion-icon>
                      Customer Portal
                      <br />
                      <span style="font-weight: 400"
                        >A full-page view of tickets</span
                      >
                    </ion-card>
                  </ion-col>
                </ion-row>
              </ion-grid>

              <div class="subtitle">Welcome heading</div>
              <ion-input
                placeholder="Ex: Hi there!"
                [(ngModel)]="widgetToEdit.title"
                class="input-field"
                style="margin: 0"
              ></ion-input>

              <div class="subtitle" style="margin-top: 15px">
                Welcome tagline
              </div>
              <ion-input
                placeholder="Ex: Ask us anything, or share some feedback"
                [(ngModel)]="widgetToEdit.tagline"
                class="input-field"
                style="margin: 0"
              ></ion-input>

              <div class="subtitle" style="margin-top: 15px">
                Typical reply time
              </div>
              <ion-select
                interface="popover"
                [(ngModel)]="widgetToEdit.replyTime"
                class="input-field"
                style="margin: 0"
              >
                <ion-select-option value="in_a_few_minutes"
                  >In a few minutes</ion-select-option
                >
                <ion-select-option value="in_a_few_hours"
                  >In a few hours</ion-select-option
                >
                <ion-select-option value="in_a_day">In a day</ion-select-option>
              </ion-select>

              <div [hidden]="widgetToEdit.isFullPageView">
                <div class="subtitle" style="margin-top: 15px">
                  Bubble position
                </div>
                <ion-select
                  interface="popover"
                  [(ngModel)]="widgetToEdit.bubblePosition"
                  class="input-field"
                  style="margin: 0"
                >
                  <ion-select-option value="right">Right</ion-select-option>
                  <ion-select-option value="left">Left</ion-select-option>
                </ion-select>

                <div class="subtitle" style="margin-top: 15px">
                  Bubble style
                </div>
                <ion-select
                  interface="popover"
                  [(ngModel)]="widgetToEdit.bubbleStyle"
                  class="input-field"
                  style="margin: 0"
                >
                  <ion-select-option value="standard"
                    >Standard</ion-select-option
                  >
                  <ion-select-option value="expanded"
                    >Expanded</ion-select-option
                  >
                </ion-select>
              </div>

              <div class="subtitle" style="margin-top: 15px">Widget color</div>
              <input
                [(colorPicker)]="widgetToEdit.color"
                [style.background]="widgetToEdit.color"
                [value]="widgetToEdit.color"
                [cpPosition]="'bottom-left'"
                [cpOutputFormat]="'hex'"
              />

              <!-- We don't handle "auto" yet so we're disabling this until we do -->
              <!-- <div class="subtitle" style="margin-top: 15px">Dark mode</div>
              <ion-select interface="popover" [(ngModel)]="widgetToEdit.darkMode" class="input-field" style="margin: 0">
                <ion-select-option value="light">Light</ion-select-option>
                <ion-select-option value="dark">Dark</ion-select-option>
                <ion-select-option value="auto">Auto-detect</ion-select-option>
              </ion-select> -->

              <div class="subtitle" style="margin-top: 15px">
                Enable ticket type selection
              </div>
              <ion-select
                interface="popover"
                [(ngModel)]="widgetToEdit.ticketTypesEnabled"
                class="input-field"
                style="margin: 0"
              >
                <ion-select-option [value]="false">Disabled</ion-select-option>
                <ion-select-option [value]="true">Enabled</ion-select-option>
              </ion-select>
              <p>
                Require users to select a ticket type and fill out required
                fields before submitting a ticket. Learn more about
                <a
                  href="https://docs.unthread.io/conversations/ticket-types"
                  target="_blank"
                  >Ticket Types</a
                >
              </p>
            </ion-card-content>

            <ion-card-title class="card-title border-top">
              <h3>Post to Slack Channel</h3>
              <div class="subtitle">
                Select the internal channel where new conversations will be
                posted
              </div>
            </ion-card-title>
            <ion-card-content>
              <app-channel-selector
                [channel]="widgetToEdit.slackChannel"
                (channelDidChange)="
                  onWidgetChannelChanged(widgetToEdit, $event)
                "
                [defaultInternalOnly]="true"
              ></app-channel-selector>
            </ion-card-content>

            <ion-card-title class="card-title border-top">
              <h3>SLA</h3>
              <div class="subtitle">
                Determine how incoming messages are assigned, escalated, and
                triaged.
              </div>
            </ion-card-title>
            <app-support-steps
              *ngIf="!isLoading"
              [initialSupportSteps]="widgetToEdit.supportSteps"
              (didChange)="supportStepsDidChange($event)"
              [createdBy]="authService.userId"
            >
            </app-support-steps>

            <ion-card-title class="card-title border-top">
              <h3>Email Notifications</h3>
              <div class="subtitle">
                Unread in-app chat messages will be emailed to customer
              </div>
            </ion-card-title>
            <ion-card-content>
              <div class="subtitle" style="margin-top: 15px">
                Send emails from
              </div>
              <ion-select
                interface="popover"
                [(ngModel)]="widgetToEdit.linkedInboundEmailRuleId"
                class="input-field"
                style="margin: 0"
                placeholder="Default ({{
                  authService.subdomain
                }}@mail.unthread.io)"
              >
                <ion-select-option [value]="null">None</ion-select-option>
                <ion-select-option
                  *ngFor="let inboundEmailRule of inboundEmailRules"
                  [value]="inboundEmailRule.id"
                  >{{ inboundEmailRule.customer?.name }}</ion-select-option
                >
              </ion-select>
            </ion-card-content>

            <ion-card-title class="card-title border-top flex-space-between">
              <h3 style="margin-bottom: 18px" class="list-header">
                Autoresponder
              </h3>
            </ion-card-title>

            <app-autoresponder
              [isDefault]="false"
              [initialAutoresponder]="widgetToEdit.autoresponder"
              (autoresponderDidChange)="
                autoresponderDidChange(widgetToEdit, $event)
              "
              [projectId]="projectId ?? undefined"
            ></app-autoresponder>
          </ion-col>
          <ion-col size="12" size-md="6" class="no-padding">
            <div style="padding: 30px; position: sticky; top: 0">
              <ion-button
                fill="clear"
                color="dark"
                (click)="leftTab = 'preview'"
                [ngClass]="{ 'pill-button-active': leftTab === 'preview' }"
              >
                Preview
              </ion-button>
              <ion-button
                fill="clear"
                color="dark"
                (click)="leftTab = 'code'"
                [ngClass]="{ 'pill-button-active': leftTab === 'code' }"
              >
                Code
              </ion-button>
              <div [hidden]="leftTab !== 'code'">
                <div *ngIf="widgetToEdit && widgetToEdit.id">
                  <h5>Embed within the <code>&lt;head&gt;</code> tag:</h5>
                  <div class="hljs javascript code-background">
                    <a
                      ngxTippy
                      data-tippy-content="Copy to clipboard"
                      class="clipboard-icon"
                      (click)="copyToClipboard(widgetToEdit)"
                    >
                      <ion-icon name="copy-outline"></ion-icon>
                    </a>
                    <pre><code [innerHTML]="getCodeHtml(widgetToEdit)"></code></pre>
                  </div>
                  <div *ngIf="widgetToEdit.isFullPageView">
                    <h5>Embed iFrame</h5>
                    <div class="hljs javascript code-background">
                      <a
                        ngxTippy
                        data-tippy-content="Copy to clipboard"
                        class="clipboard-icon"
                        (click)="copyIFrameHtml()"
                      >
                        <ion-icon name="copy-outline"></ion-icon>
                      </a>
                      <pre><code [innerHTML]="getIFrameHtml()"></code></pre>
                    </div>
                  </div>
                  <h5>Identity verification secret</h5>
                  <div class="flexed">
                    <ion-input
                      [disabled]="true"
                      [(ngModel)]="widgetToEdit.verificationSecret"
                      class="input-field"
                      [type]="verificationSecretShown ? 'text' : 'password'"
                      style="margin: 0"
                    ></ion-input>
                    <ion-button
                      fill="clear"
                      (click)="toggleVerificationSecret()"
                      >{{
                        verificationSecretShown ? "Hide" : "Show"
                      }}</ion-button
                    >
                  </div>
                </div>
                <div
                  style="padding: 30px 15px; text-align: center; color: #666"
                  *ngIf="!widgetToEdit?.id"
                >
                  Save changes to generate code snippet
                </div>
              </div>
              <div
                class="preview"
                style="margin-top: 20px"
                [hidden]="leftTab !== 'preview'"
              >
                <ion-card
                  *ngIf="widgetToEdit.isFullPageView"
                  style="text-align: center"
                >
                  <ion-card-content>
                    <a
                      href="https://docs.unthread.io/in-app/customer-portal"
                      target="_blank"
                      >View docs about the customer portal
                      <ion-icon name="open-outline"></ion-icon
                    ></a>
                  </ion-card-content>
                </ion-card>
                <div
                  style="
                    border-radius: 12px;
                    box-shadow: 0px 3px 16px -8px #666;
                    max-width: 420px;
                    margin-left: auto;
                    margin-right: auto;
                    color: black;
                  "
                  *ngIf="!widgetToEdit.isFullPageView"
                >
                  <div
                    style="padding: 15px; border-radius: 12px 12px 0 0"
                    [ngClass]="{
                      'preview-black': isDarkModePreview,
                      'preview-white': !isDarkModePreview
                    }"
                  >
                    <h2>
                      {{ widgetToEdit.title || "Title" }}
                    </h2>
                    <p style="margin: 0">
                      {{ widgetToEdit.tagline || "Tagline" }}
                    </p>
                  </div>
                  <div
                    style="
                      padding: 300px 15px 15px 15px;
                      border-radius: 0 0 12px 12px;
                    "
                    [ngClass]="{
                      'preview-dark': isDarkModePreview,
                      'preview-white': !isDarkModePreview
                    }"
                  >
                    <p *ngIf="widgetToEdit.replyTime === 'in_a_few_minutes'">
                      Typically replies in a few minutes
                    </p>
                    <p *ngIf="widgetToEdit.replyTime === 'in_a_few_hours'">
                      Typically replies in a few hours
                    </p>
                    <p *ngIf="widgetToEdit.replyTime === 'in_a_day'">
                      Typically replies in a day
                    </p>
                    <ion-button
                      size="block"
                      class="btn-large"
                      [ngStyle]="{ '--background': widgetToEdit.color }"
                      >Start conversation</ion-button
                    >
                  </div>
                </div>

                <div
                  style="
                    margin-top: 21px;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <div
                    class="round-pill-tab round-pill-tab-left"
                    [ngClass]="{
                      'round-pill-tab-active': !isDarkModePreview
                    }"
                    (click)="isDarkModePreview = false"
                  >
                    Light
                  </div>
                  <div
                    class="round-pill-tab round-pill-tab-right"
                    [ngClass]="{
                      'round-pill-tab-active': isDarkModePreview
                    }"
                    (click)="isDarkModePreview = true"
                  >
                    Dark
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer>
      <ion-button
        (click)="save(widgetToEdit)"
        class="save-button"
        [disabled]="!featureEnabled || isLoading"
      >
        {{ isLoading ? "Updating..." : "Save changes" }}
        <ion-spinner
          name="crescent"
          style="margin-left: 5px"
          *ngIf="isLoading"
        ></ion-spinner>
      </ion-button>
      <ion-button
        fill="clear"
        (click)="dismissWidgetEditor()"
        *ngIf="hasWidgets"
      >
        Cancel
      </ion-button>
      <ion-button
        color="danger"
        fill="clear"
        (click)="delete(widgetToEdit)"
        *ngIf="widgetToEdit?.id"
        [disabled]="isLoading"
      >
        Disable
      </ion-button>
    </ion-footer>
  </ng-template>
</ion-modal>
